import { connect } from 'react-redux';
import { compose, withHandlers, lifecycle } from 'recompose';

import { replace } from 'connected-react-router';

import routes from 'utils/routes';
import { actions as orderActions } from 'state/order';

import { userIsAuthenticatedRedir } from 'components/auth/hoc';
import CreditCard from 'pages/CreditCard/styled';

const enhance = compose(
  connect(() => ({}), {
    replaceRoute: replace,
    checkPaymentMethod: orderActions.checkPaymentMethod,
  }),
  withHandlers({
    handleBack:
      ({ replaceRoute }) =>
      () =>
        replaceRoute(routes.summary),
  }),
  lifecycle({
    componentDidMount() {
      const { checkPaymentMethod } = this.props;
      checkPaymentMethod();
    },
  }),
  userIsAuthenticatedRedir
);

export default enhance(CreditCard);
